enum PageAlertVariantEnum {
	NORMAL = 'normal',
	COLLAPSED = 'collapsed',
}

export {PageAlertVariantEnum};
